<template>
    <Content
      :router="{
        name: 'REPORT_RULES_LIST',
      }"
      v-loading="loading"
      class="col-span-full"
      :title="$route.name"
    >
      <div
        v-if="!!result"
        class="
          flex
          lg:gap-12
          gap-6
          flex-col
          lg:flex-row
          flex-wrap
          items-start
          justify-start
        "
      >
        <Field :title="$t('VEHICLE_TITLE')" type="col" align="start">
          <LicensePlate
            type="dashboard"
            :vehicle="result.company_vehicle.vehicle"
            :color="result.company_vehicle.color"
            :license_plate="result.company_vehicle.license_plate"
            :chars="alphaList"
          >
          </LicensePlate>
        </Field>
        <Field
          v-if="result.company_vehicle.driver"
          :title="$t('DRIVER_TITLE')"
          type="col"
          align="start"
        >
          <p>
            {{
              result.company_vehicle.driver.first_name +
              " " +
              result.company_vehicle.driver.last_name
            }}
          </p>
        </Field>
  
        <Field :title="$t('TIME')" type="col" align="start">
          <div class="flex items-center gap-2 ltr">
            <span class="rtl"
              >{{ new Date(result.start_time).toLocaleTimeString("fa-IR") }}
              |
              {{
                new Date(result.start_time).toLocaleDateString("fa-IR")
              }}</span
            >
            <template v-if="result.end_time">
              <span class="text-gray-500"> - </span>
              <span class="rtl">
                {{ new Date(result.end_time).toLocaleTimeString("fa-IR") }}
                |
                {{ new Date(result.end_time).toLocaleDateString("fa-IR") }}
              </span>
            </template>
          </div>
        </Field>
  
        <Field
          :title="$t('DURATION_TIME') + ' (' + $t('HOUR') + ')'"
          type="col"
          align="start"
        >
          <span>
            {{ calculateHour(result.route.duration) }}
          </span>
        </Field>
  
        <Field :title="$t('ODOMETER')" type="col" align="start">
          <span
            v-html="$options.filters.numberSeperator1(result.route.length / 1000)"
          >
          </span>
        </Field>
  
        <Field :title="$t('MAX_SPEED')" type="col" align="start">
          {{ result.route.max_speed }}
          <span class="mx-1 text-xs text-gray-500 font-light">
            ({{ $t("KM_H") }})
          </span>
        </Field>
        <Field :title="$t('AVG_SPEED')" type="col" align="start">
          {{ result.route.mean_speed }}
          <span class="mx-1 text-xs text-gray-500 font-light">
            ({{ $t("KM_H") }})
          </span>
        </Field>
      </div>
      
      <RulesDetail v-if="!!result" :result="result" />
    </Content>
  </template>
  <script>
  import RulesDetail from "@/pages/reports/components/rulesDetail.vue";
  import { RuleEventDetail } from "@/api/reports";
  import Field from "@/components/elements/field";
  import LicensePlate from "@/components/cars/LicensePlate";
  import { calculateHour } from "@/mixins/calculateHour";
  import { licenseChars } from "@/api/global";
//   import Notice from "@/components/elements/notice";
  
  export default {
    mixins: [calculateHour],
    data() {
      return {
        result: null,
        loading: true,
        alphaList: [
          {
            char: "",
            code: "",
          },
        ],
      };
    },
    mounted() {
        RuleEventDetail.api(this.$route.params.id).then((res) => {
        if (res) {
          this.result = res;
          this.loading = false;
        }
      });
      licenseChars.api().then((res) => {
        this.alphaList = res;
      });
    },
    components: {
      RulesDetail,
      Field,
      LicensePlate,
      
    },
  };
</script>